"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateResponse = exports.validateData = exports.getCacheValue = exports.default = void 0;
var _utils = require("./utils");
var _reportError = _interopRequireDefault(require("./reportError"));
// Changes every 16 minutes
const getCacheValue = () => {
  const dateString = Date.now().toString();
  return dateString.slice(0, 7);
};
exports.getCacheValue = getCacheValue;
const validateResponse = response => {
  if (!response.ok) {
    throw new Error(`HTTP Status ${response.status} ${response.statusText}`);
  }
};

// TODO: Improve error messages. The most common unhappy scenario, where a script
// doesn't have a satisfying version in the registry, will result in a very
// confusing & unintuitive series of error messages right now.
exports.validateResponse = validateResponse;
const validateData = (data, bundleObj) => {
  var _window, _window2;
  const dataErrorType = 'ScriptRegistryDataError';
  const localeOnPage = ((_window = window) === null || _window === void 0 ? void 0 : _window.UCMPageLocale) || ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scriptSupplierPageLocale);
  let currentError = '';
  if (!(0, _utils.isValidObject)(data)) {
    currentError = 'Invalid Response Data';
    (0, _reportError.default)(dataErrorType, currentError, localeOnPage);
    throw new Error(currentError);
  }
  if (!(0, _utils.isValidString)(data.name) && !(0, _utils.isValidString)(data.version)) {
    currentError = 'Name and version both missing. Probably unable to find script with given name and version range in the script registry.';
    (0, _reportError.default)(dataErrorType, currentError, localeOnPage);
    throw new Error(currentError);
  }
  if (!(0, _utils.isValidString)(data.name)) {
    currentError = 'Name Missing';
    (0, _reportError.default)(dataErrorType, currentError, localeOnPage);
    throw new Error(currentError);
  }
  if (!(0, _utils.isValidString)(data.version)) {
    currentError = 'Version Missing';
    (0, _reportError.default)(dataErrorType, currentError, localeOnPage);
    throw new Error(currentError);
  }
  if (!(0, _utils.isValidObject)(bundleObj)) {
    currentError = 'Invalid Script Bundle';
    (0, _reportError.default)(dataErrorType, currentError, localeOnPage);
    throw new Error(currentError);
  }
  if (!(0, _utils.isValidObject)(bundleObj.attributes)) {
    currentError = 'Script Attributes Missing';
    (0, _reportError.default)(dataErrorType, currentError, localeOnPage);
    throw new Error(currentError);
  }
  if (!(0, _utils.isValidObject)(bundleObj.classifications)) {
    currentError = 'Script Classifications Missing';
    (0, _reportError.default)(dataErrorType, currentError, localeOnPage);
    throw new Error(currentError);
  }
  if (!(0, _utils.isValidString)(bundleObj.attributes.src)) {
    currentError = 'Script Source Missing';
    (0, _reportError.default)(dataErrorType, currentError, localeOnPage);
    throw new Error(currentError);
  }
};
exports.validateData = validateData;
const fetchScriptData = _ref => {
  let {
    fetchFn,
    url,
    environment,
    name,
    version
  } = _ref;
  const params = new URLSearchParams();
  params.append('name', name);
  params.append('version', version);
  params.append('environment', environment);
  params.append('cache', getCacheValue());
  return fetchFn(`${url}?${params.toString()}`).then(response => {
    try {
      validateResponse(response);
      return response.json();
    } catch (error) {
      return response.text().then(text => {
        var _window3, _window4;
        (0, _reportError.default)('ReadScriptRegistryError', text, ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.UCMPageLocale) || ((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.scriptSupplierPageLocale));
        throw new Error(text);
      });
    }
  }).then(data => {
    let bundleObj = null;
    try {
      bundleObj = JSON.parse(data.bundle);
    } catch (error) {
      // ignore
    }
    validateData(data, bundleObj);
    return {
      name: data.name,
      version: data.version,
      attributes: bundleObj.attributes,
      classifications: bundleObj.classifications
    };
  });
};
var _default = fetchScriptData;
exports.default = _default;